import React, { useEffect, useState } from 'react';
import { LocaleHelper } from '../../../helpers/locale';
import FormSelect from '../FormSelect';

const SelectLocalLevel1 = ({ className, country, ...rest }) => {
  const [options, setOptions] = useState([]);

  async function updateOptions() {
    const data = await LocaleHelper.getLV1ListInt(country);
    setOptions(
      data.map(({ code, name }) => ({
        value: code,
        label: name,
      })),
    );
  }

  useEffect(() => {
    updateOptions();
  }, [country]);

  const loading = options.length === 0;

  return (
    <FormSelect
      className={className}
      {...rest}
      isDisabled={rest.disabled}
      loading={loading}
      autoComplete="$$##@@@"
      placeholder={''}
      //filterOption={(inputValue, option) => option.label.toUpperCase().indexOf(inputValue.toUpperCase()) >= 0}
      options={options}
    />
  );
};

export default SelectLocalLevel1;
